import { sendEvent } from 'libs/event';
import urlParams from 'libs/query';
import env from 'libs/env';
import generateGuid from './guid';

export enum EPageType {
    订单列表页 = 18,
    发表评价页 = 60,
    追评页 = 61,
    订单详情 = 86,
    物流详情 = 97,
    申请售后选择商品 = 179,
    申请售后选择退款方式 = 180,
    申请售后填写原因 = 181,
    售后详情页 = 182,
    填写退货物流页 = 183,
    评价完成页 = 184,
    查看评价页 = 185,
    改好评页 = 186,
    换货申请页 = 901,
    换货详情页 = 902,
    换货物流填写页 = 903,
    地址列表页 = 89,
    地址编辑页 = 90,
    修改地址页 = 195
}

let handle = 0;
const guid = generateGuid();

export default {
    pv(page_type: number, extra: any = {}) {
        Object.assign(window, {
            page_type,
            page_id: '0'
        });
        sendEvent('page_view', {
            ...extra,
            order_id: urlParams.id || urlParams.order_id,
            b_type: env.bType
        });
    },

    stay(page_type: number, extra: any = {}) {
        if (process.env.NODE_ENV === 'development') return;
        Object.assign(window, {
            page_type,
            page_id: '0'
        });
        const supplement = {
            order_id: urlParams.order_id,
            duration: '1',
            unique_id: guid,
            b_type: env.bType
        };
        const data = { ...supplement, ...extra };

        if (handle) {
            window.clearInterval(handle);
        }

        handle = window.setInterval(() => {
            if (document.visibilityState === 'visible') {
                sendEvent('page_stay', data);
            }
        }, 1000);
    }
};
